import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";


const OkModal = ({ visible, title, message, onOkPress }) => (
    <Dialog open={visible} onClose={onOkPress}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onOkPress} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );

  export default OkModal